module.exports = __webpack_public_path__ + "img/play_b1.23327a94.png";